module.exports = __webpack_public_path__ + "img/guide_finish.c0032e1b.svg";